// src/hooks/useLogin.ts
import { useState, ChangeEvent, FormEvent } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { URL_SERVER } from '../utils/Utils';
import secureLocalStorage from 'react-secure-storage';

const useLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [resetEmail, setResetEmail] = useState('');
  const [resetMessage, setResetMessage] = useState('');
  const [newPassword, setNewPassword] = useState('');

  const navigate = useNavigate();

  const handleLogin = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError('');
    try {
      const response = await axios.post(`${URL_SERVER}/login`, { email, password });
   const token = typeof response.data === "string"
  ? response.data
  : response.data.token;

console.log("LOGIN RESPONSE:", response.data);
console.log("TOKEN GUARDADO:", token);

secureLocalStorage.setItem('token', token);
secureLocalStorage.setItem('email', email);
      navigate('/redirect');
      
    } catch (err) {
      console.error('Error en el login:', err);
      setError('Credenciales incorrectas. Inténtalo de nuevo.');
    }
  };

  const openModal = () => {
    setResetEmail('');
    setResetMessage('');
    setNewPassword('');
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);

  const handleResetChange = (e: ChangeEvent<HTMLInputElement>) => {
    setResetEmail(e.target.value);
  };

 const handlePasswordReset = async (e: FormEvent) => {
  e.preventDefault();
  setResetMessage('');
  try {
    await axios.post(`${URL_SERVER}/${resetEmail}/forgot-password`);

    setResetMessage(
      'Si el correo existe, recibirás un email con el enlace para cambiar tu contraseña, una vez recibido y verificado, introduzca su nueva contraseña y pulse el botón de confirmar contraseña'
    );
  } catch (err) {
    console.error('Error al solicitar el enlace de restablecimiento:', err);
    setResetMessage('Error al solicitar el enlace de restablecimiento.');
  }
};

  const handleConfirmNewPassword = async () => {
    try {
      await axios.put(`${URL_SERVER}/password`, {
  email: resetEmail,
  password: newPassword
});
      setResetMessage('Contraseña actualizada correctamente.');
    } catch (err) {
      console.error('Error al actualizar la contraseña:', err);
      setResetMessage('Error al actualizar la contraseña.');
    }
  };

  return {
    email,
    setEmail,
    password,
    setPassword,
    error,
    isModalOpen,
    resetEmail,
    resetMessage,
    newPassword,
    setNewPassword,
    handleLogin,
    openModal,
    closeModal,
    handleResetChange,
    handlePasswordReset,
    handleConfirmNewPassword
  };
};

export default useLogin;